import Vue from 'vue';

import { AnalyticsState, MutationClass, PeriodsData } from '../../../models';

export class SetPivotDataMutation implements MutationClass {

  public static execute(state: AnalyticsState, payload: { data: Partial<PeriodsData>; pivotId: string; selectedId?: string; }): void {
    if (!payload.selectedId) {
      const pivotData = state.data.overall.pivots[payload.pivotId];
      if (!pivotData) {
        Vue.set(state.data.overall.pivots, payload.pivotId, payload.data);
      } else {
        state.data.overall.pivots[payload.pivotId] = Object.assign({}, pivotData, payload.data);
      }
    } else {
      const selectedIdData = state.data.ids[payload.selectedId];
      if (!selectedIdData) {
        Vue.set(state.data.ids, payload.selectedId, {
          dist: {
            currentPeriod: undefined
          },
          pivots: {
            [payload.pivotId]: payload.data
          },
          related: {}
        });
      } else {
        const pivotData = selectedIdData.pivots[payload.pivotId];
        if (!pivotData) {
          Vue.set(selectedIdData.pivots, payload.pivotId, payload.data);
        } else {
          selectedIdData.pivots[payload.pivotId] = Object.assign({}, pivotData, payload.data);
        }
      }
    }
  }

}
